import Model, { attr, belongsTo } from '@ember-data/model';

export default class MonarchChannelClientInfoModel extends Model {
  @belongsTo('global-monarch-channel', { async: false, inverse: null }) globalMonarchChannel;
  @belongsTo('treatable-client', {
    async: false,
    inverse: 'monarchChannelClientInfos',
    polymorphic: true,
  })
  client;

  @attr('number') coveredSessionsCount;
  @attr('number') remainingSessionsCount;

  static fieldsFor(_context) {
    let fields = [];
    this.fields.forEach((_, v) => fields.push(v));

    return fields.filter(field => !['meta', 'client'].includes(field));
  }
}
